import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { AuthorizationService, UserService } from '../../services';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EncrDecrService } from '../../../../Providers/EncrDecrService';
import { ApiService } from '../../../project/services/api.service';

//import { IImage } from 'ng-simple-slideshow';
import { BehaviorSubject } from 'rxjs';
//import * as Plyr from 'plyr';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule] 
})
export class LoginComponent implements OnInit {
  buildversion?: string;
  appname?: string;

  public player: any = null;
  public _loginUrl: string = 'Userlogin/SingIn';
  public _forgotUrl: string = 'Userlogin/ForgotPassword';
  public _contactusUrl: string = 'Userlogin/ContactUs';
  public _newsLetterSubscribeUrl: string = 'Userlogin/SubscribeNewLetter';
  public _fetchWorkspaceDetailsUrl: string = 'Userlogin/FetchWorkspaceDetails';
  public _getFAQQuestionList: string = 'Userlogin/GetFAQQuestionList';
  public _fetchActiveProductId: string = 'SurveyServiceLine/GetActiveProduct';
  public _getEditUrl: string = 'SurveyServiceLine/EditServiceLineList/';
  public _isValidUserUrl: string = 'Userlogin/IsValidUser';
  myAppUrl: any;
  signinnewlist: string = '';
  loginForm!: FormGroup;
  public filterName: any;
  forgotAccountForm!: FormGroup;
  contactusForm!: FormGroup;
  message: string = '';
  public workspaceDetails?: WorkSpace;
  public workSpaceId: any = 2;
  public newsLetterEmail: any;
  validinvalidmessage: string = '';
  newsLetterMsg: string = '';
  public FAQList?: FAQQuestionList[];
  signIn?: any;
  isAuthenticated: boolean = false;
  returnUrl: string = '';
  HTTPActivity: boolean = false;
  userEmail?: any;
  defaultList = new BehaviorSubject<FAQQuestionList[]>([]);
  constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    , private router: Router
    , private formBuilder: FormBuilder
    , @Inject('BASE_URL') baseUrl: string
    , private _apiService: ApiService
    , private EncrDecr: EncrDecrService
    , @Inject('CONFIG_SETTINGS') config: any
    , private userService: UserService
    , private http: HttpClient) {
    const configSettings = config['appbuild'];
    this.buildversion = configSettings['version'];
    this.appname = configSettings['name'];


    this.checkUserLoggedIn()

    this._apiService.FetchWorkspaceDetails().subscribe(
      async result => {
        this.workSpaceId = result.workSpaceId;
        this.workspaceDetails = result;
      
      }, error => { alert(error.message) });

  }

  async ngOnInit() {
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
    if (isAuthenticated) {
      this.router.navigate(['question']);
    }

    this.loginForm = this.formBuilder.group({
      userName: [''],
      password: ['']
    });
    this.forgotAccountForm = this.formBuilder.group({
      email: ['']
    });
    this.contactusForm = this.formBuilder.group({
      companyname: [''],
      firstname: [''],
      lastname: [''],
      email: [''],
      comments: ['']
    });
  }

  async getLoggedInUserEmail(): Promise<string | undefined> {
    let email: string | undefined = '';

    //get Logged In User Email ID using OKTA method
    await this.oktaAuth.getUser().then(userDetail => {
      if (userDetail) {
        email = userDetail.email;
      }
    });
    return email;
  }

  CloseForm() {
    //this.loginForm.reset();
  }

  login() {
    localStorage.setItem('isLoggedIn', "false");
    localStorage.removeItem('RoleId');
    localStorage.removeItem('RoleName');
    localStorage.removeItem('userId');
    localStorage.clear();
    this.oktaAuth.signInWithRedirect();
  }

  async checkUserLoggedIn() {
    try {
      this.isAuthenticated = await this.oktaAuth.isAuthenticated();
      console.log("isAuthenticated", this.isAuthenticated);
      if (this.isAuthenticated === true) {
        const token = this.oktaAuth.getAccessToken();
        if (token) {
          const user = await this.oktaAuth.getUser();
          console.log("user_login", user);
          console.log("token_login", token);

          if (user !== null && user !== undefined) {
            const userName = user.preferred_username;
            console.log("userName", userName);
            this.userEmail = userName;            
            this._apiService.IsValidUserDetails(this.userEmail).subscribe(
              result => {
                if (result.roleId > 0) {
                  localStorage.setItem('RoleId', this.EncrDecr.set(result.roleId.toString()));
                  localStorage.setItem('RoleName', this.EncrDecr.set(result.roleName.toString()));
                  localStorage.setItem('userId', this.EncrDecr.set(result.userId));
                  localStorage.setItem('workspaceId', this.EncrDecr.set(result.workspaceId));
                  localStorage.setItem('companyId', this.EncrDecr.set(result.companyId));
                  localStorage.setItem('jwttoken', result.jwttoken);
                  if (result.roleName == "Admin") {
                    this.signIn.loginRedirect('/question', { sessionToken: token });
                  }
                  this.router.navigate(['home']);
                } else {
                  this.validinvalidmessage = "You are not authorized to access this application. Please contact administrator.";
                  localStorage.setItem('isLoggedIn', "false");
                  this.oktaAuth.signOut({
                    postLogoutRedirectUri: window.location.origin + '/login'
                  });
                }
              }, error => { alert(error.message) });


          }
        } else {
          console.log("No access token available.");
        }
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  FetchWorkspaceLogo() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };
    this.http.post<WorkSpace>(this.myAppUrl + this._fetchWorkspaceDetailsUrl, 'hostName=' + this.myAppUrl, httpOptions).subscribe(
      result => {
        this.workSpaceId = result.workSpaceId;
        this.workspaceDetails = result;
      }, error => { alert(error.message) });
  }

  contactsumbit() {

  }

  forgotPassword() {


  }

  stopPlayer() {
    this.player.stop();
    this.player.source = "";
  }
  signUp(newsLetterEmail: string) {

  }

  onKeydown(event: KeyboardEvent): void {
    // Optional: Add logic if needed
  }

  onKeydownForgot(event: KeyboardEvent): void {
    // Optional: Add logic if needed
  }

  currentYearLong(): number {
    return new Date().getFullYear();
  }
}

interface Login {
  userName: string;
  password: string;
}
interface WorkSpace {
  workSpaceId: number;
  workSpaceName: string;
  workSpaceLogo: string;
  hostName: string;
  loginPageLogo: string;
  supportEmail: string;
}
interface FAQQuestionList {
  questionText: string;
  answer: string;
  imageBlob: string;
}
